import { Link } from "@remix-run/react";
import { getFormattedCountryName } from "~/lib/helpers/constants";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { DollarSign, MapPinned, User, Users } from "lucide-react";
import { getCurrentCustomerCount } from "~/lib/helpers/StringHelper";

export default function OfficeSearchAndPartnerSection({ region, countryName, searchUrl }: { region: string, countryName: string, searchUrl: string }) {

    return (
        <>
            <section className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                {/* Text Section */}
                <div className="space-y-3">
                    <h2 className="text-sm text-gray-500 font-semibold uppercase mb-1">Office Search</h2>
                    <p className="text-3xl font-bold leading-tight">
                        Exclusive Office Offers from Our Trusted Partners
                    </p>
                    <p className="text-gray-600">
                        Access premium workspaces across {getFormattedCountryName(region)} through our trusted partner network. We’ve teamed up with leading coworking and serviced office providers to bring you verified spaces, flexible lease options, exclusive discounts, and unbeatable pricing—all in one place.
                    </p>
                    <p className="text-gray-600">
                        From flexible coworking desks to entire serviced floors, our {getFormattedCountryName(region)} team is here to help you find and secure the perfect space with ease. <b>Best of all our legendary service is totally free for tenants to find space.</b>
                    </p>

                    <ul className="space-y-2 py-3">
                        <li className="flex items-center gap-3 text-gray-600">
                            <MapPinned size={20} className="text-gray-500 flex-shrink-0" />
                            <span>35,000+ workspace locations worldwide (110 countries)</span>
                        </li>
                        <li className="flex items-center gap-3 text-gray-600">
                            <User size={20} className="text-gray-500 flex-shrink-0" />
                            <span>Personalized guidance from our expert team</span>
                        </li>
                        <li className="flex items-center gap-3 text-gray-600">
                            <DollarSign size={20} className="text-gray-500 flex-shrink-0" />
                            <span>We guarantee the best price, every time</span>
                        </li>
                        <li className="flex items-center gap-3 text-gray-600">
                            <Users size={20} className="text-gray-500 flex-shrink-0" />
                            <span>Over {getCurrentCustomerCount()} clients served since 2013</span>
                        </li>
                    </ul>
                    <Link to={searchUrl} target="_blank" >
                        <OhButton
                            className=" mt-4  w-fit"
                        >
                            Search Office Space
                        </OhButton>
                    </Link>
                </div>



                <div className="relative w-full rounded-xl overflow-hidden">

                    <div className="relative rounded-xl overflow-hidden shadow-lg">
                        <img
                            src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/about-us-side-image.avif`}
                            alt="Successful business deal celebration for exclusive Office Hub partner offers in a flexible workspace"
                            title="Exclusive Office Deals"
                            width={600}
                            height={400}
                            className="object-cover w-full h-full"
                        />

                    </div>
                </div>
            </section>

        </>
    );
} 